import { useState } from 'react'

import { useRequestInfos } from './hooks/useRequestInfos/useRequestInfos'

import { Divider, Grid, Paper } from 'presentation/components/atoms'
import { Content, Background } from 'presentation/components'
import { Payment, CartSkeleton, Details, NoItems } from 'presentation/components/orders'
import { PageHeader } from 'presentation/components/molecules'
import { useOrder } from './hooks/useOrder'

interface PaymentConfirmationProps {
  location: {
    pathname: string
    state: {
      orderId: string
      method: number
      title: 'Recarga' | 'Cartão 1ª via' | 'Cartão 2ª via'
      quantity: number
      operatorCardName: string
    }
  }
}

export const PaymentConfirmation = ({ location }: PaymentConfirmationProps) => {
  const [loading, setLoading] = useState(false)
  const [method, setMethod] = useState<'PIX' | 'SLIP'>()

  const orderId = location.state?.orderId

  const [balanceToBeUsed, setBalanceToBeUsed] = useState(0)
  const [useBalanceProjection, setUseBalanceProjection] = useState(false)

  const { data, details } = useRequestInfos({ orderId, setLoading, pathname: location.pathname })
  const { confirmOrder, cancelOrder } = useOrder({
    orderId,
    method,
    loading,
    setLoading,
    balanceUsage: balanceToBeUsed,
    data,
    useBalanceProjection,
    pathname: location.pathname,
  })

  const isEmpty = location.state?.quantity <= 0

  return (
    <Background>
      <Content>
        <Paper sx={{ padding: '32px' }}>
          <Grid container justifyContent='space-between' spacing={2}>
            <Grid item xs={12}>
              <PageHeader pageTitle='Comprar agora' noDivider padding='0' />
            </Grid>
          </Grid>
          <Divider sx={{ margin: '32px 0' }} />
          {loading ? (
            <CartSkeleton />
          ) : (
            <Grid container columnSpacing='32px' rowSpacing='32px'>
              <Grid item xs={12} md={7}>
                {isEmpty ? (
                  <NoItems />
                ) : (
                  <Details
                    title={location.state?.title}
                    items={details}
                    totalItems={data?.numberOfColaborators}
                    operatorCardName={location.state?.operatorCardName}
                    cancelOrder={cancelOrder}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={5}>
                <Payment
                  isEmpty={isEmpty}
                  order={data}
                  balanceToBeUsed={balanceToBeUsed}
                  setBalanceToBeUsed={setBalanceToBeUsed}
                  setUseBalanceProjection={setUseBalanceProjection}
                  shouldUseProjection={useBalanceProjection}
                  confirmOrder={confirmOrder}
                  setMethod={setMethod}
                  method={method}
                />
              </Grid>
            </Grid>
          )}
        </Paper>
      </Content>
    </Background>
  )
}
